import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcMediaPdf = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.828 2 27 7.555V30H5V2h15.828ZM19 4H7v24h18V10h-6V4Zm-8.016 9.136c1.216 0 1.952.744 1.952 1.928 0 1.136-.728 1.936-1.96 1.936h-1.24v2H8.64v-5.864Zm4.88 0c1.68 0 2.952 1.208 2.952 2.936 0 1.736-1.256 2.928-2.952 2.928h-2.072v-5.864Zm7.56 0-.008 1.024h-2.568v1.488h2.168l-.008.984h-2.16V19H19.76v-5.864h3.664Zm-7.568 1.016h-.968v3.84h.968c1.104 0 1.808-.784 1.808-1.92 0-1.128-.712-1.92-1.808-1.92Zm-5.072-.048H9.736v1.944h1.04c.712 0 1.008-.472 1.008-1.008 0-.48-.296-.936-1-.936ZM21 4.845V8h3.506L21 4.845Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
export default SvgIcMediaPdf;
